import React, { useEffect, useState } from 'react';
import { History } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const COLORS = {
  admin_go: 'bg-emerald-100 text-emerald-800', admin_nogo: 'bg-red-100 text-red-800', admin_review: 'bg-amber-100 text-amber-800',
  counter_proposal: 'bg-orange-100 text-orange-800', direction_decision_modified: 'bg-slate-200 text-slate-800',
  counter_accepted: 'bg-emerald-50 text-emerald-700', counter_refused: 'bg-red-50 text-red-700',
};
const eur = (v) => `${Math.round(v).toLocaleString('fr-FR')} €`;

export const DecisionHistory = ({ simulationId, refreshKey }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    fetch(`${API}/api/simulations/${simulationId}/decisions-history`, { headers: { Authorization: `Bearer ${localStorage.getItem('capex_token')}` } })
      .then(r => (r.ok ? r.json() : [])).then(setRows).catch(() => setRows([]));
  }, [simulationId, refreshKey]);
  if (!rows || rows.length === 0) return null;
  return (
    <details className="rounded-xl border border-slate-200 bg-white px-4 py-3" data-testid="decision-history" open={rows.length <= 3}>
      <summary className="flex cursor-pointer items-center gap-2 text-sm font-semibold text-slate-700">
        <History className="h-4 w-4 text-orange-600" />Historique des décisions de la Direction · {rows.length}
      </summary>
      <ol className="mt-3 space-y-2 border-l-2 border-slate-200 pl-4">
        {rows.map(r => (
          <li key={r.id} className="relative" data-testid={`decision-history-${r.id}`}>
            <span className="absolute -left-[21px] top-1.5 h-2.5 w-2.5 rounded-full bg-orange-500" />
            <div className="flex flex-wrap items-center gap-2 text-xs">
              <span className={`rounded-full px-2 py-0.5 font-bold ${COLORS[r.action] || 'bg-slate-100'}`}>{r.label}</span>
              {r.ca_previsionnel_ht ? <span className="font-semibold text-slate-700">{Math.round((r.commission_rate || 0) * 100)} % · {eur(r.ca_previsionnel_ht)}</span> : null}
              <span className="text-slate-500">le {new Date(r.date).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short', timeZone: 'Europe/Paris' })} par {r.par}</span>
            </div>
            {r.commentaire && <p className="mt-1 text-xs italic text-slate-600">« {r.commentaire} »</p>}
          </li>
        ))}
      </ol>
    </details>
  );
};
